import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTheme } from "../context/ThemeContext";

// Assuming you're using a context or a global state to manage the theme.


interface BasicModalProps {
  show: boolean;
  handleClose: () => void;
  handleSave: () => void;
  title: string;
  children: React.ReactNode;
  disabled?: boolean
}

const BasicModal: React.FC<BasicModalProps> = ({ show, handleClose, handleSave, title, children, disabled }) => {
  const { theme } = useTheme(); // 'theme' could be 'light' or 'dark'

  useEffect(() => {
    // Function to handle the Enter key press
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent default form submission behavior
        handleSave();
      }
    };

    // Add event listener when modal is open
    if (show) {
      document.addEventListener("keydown", handleKeyPress);
    } else {
      document.removeEventListener("keydown", handleKeyPress);
    }

    // Clean up the event listener on component unmount or modal close
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [show, handleSave]);

  return (
    <React.Fragment>
      <Modal show={show} onHide={handleClose} className="fade zoomIn" dialogClassName="modal-dialog-centered">
        <Modal.Header closeButton className={theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
         className={theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"}
         
        >
          {children}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button disabled={disabled} variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default BasicModal;